export default function faq() {
  const faq_items = document.querySelectorAll('.faq_item');

  faq_items.forEach(el => {
    const bnt = el.querySelector('.faq_btn');

    if (el.classList.contains('active')) {
      const h = el.querySelector('.faq_body').offsetHeight;
      el.querySelector('.faq_body').style.setProperty("--blockHeight", `${h}px`);
      el.classList.remove('collapse');
    }

    bnt.addEventListener('click', () => {
      if (!el.classList.contains('active')) {

        closeAll();

        el.classList.add('collapse');
        const h = el.querySelector('.faq_body').offsetHeight;
        el.querySelector('.faq_body').style.setProperty("--blockHeight", `${h}px`);
        el.classList.remove('collapse');
        setTimeout(() => {
          el.classList.add('active');
        }, 100);
      } else {
        closeAll();
      }
    })
  });

  function closeAll() {
    faq_items.forEach(el => {
      el.classList.remove('active');
      el.classList.remove('collapse');
      el.querySelector('.faq_body').style = '';
    })
  }

}
